/* [PATCH aplikacije-fe v1] Ločitev aplikacij — seznam, barve, cilji. ID-ji = backend services/aplikacije.py (edini vir resnice tam).
   Barvni razredi so DOBESEDNI (Tailwind purge). Vrstni red = vstopna stran (Janez 24.09.2026). */
import { LayoutDashboard, FileOutput, FileInput, Landmark, Route, Clock } from 'lucide-react';

export type AplikacijaId = 'pregled' | 'prodaja' | 'nabava' | 'banka' | 'potni_nalogi' | 'delovni_cas';
export type Smer = 'prejeti_racun' | 'izdani_racun';

export interface AplikacijaOpis {
  id: AplikacijaId;
  naziv: string;
  podnaslov: string;
  aktivna: boolean;
  icon: any;
  smer: Smer | null;          // smer dokumentov v aplikaciji
  cilj: string;               // kam po izbiri podjetja (D5: takoj seznam računov)
  kartica: string;            // ozadje + rob kartice na vstopni strani
  chip: string;               // barvni čip ikone
  znacka: string;             // značka v glavi okvirja (faza 3)
}

export const APLIKACIJA_KLJUC = 'aicount_aplikacija';

export const APLIKACIJE: AplikacijaOpis[] = [
  { id: 'pregled', naziv: 'Pregled poslovanja', podnaslov: 'Kazalniki in pregled', aktivna: true, icon: LayoutDashboard, smer: null, cilj: '/pregled', /* [PATCH pregled-poslovanja-fe v1] prej aktivna: false, cilj: '/nadzorna' */
    /* [PATCH barve-aplikacij v1] nebesno modra (prej slate) — vsaka aplikacija svoja barva */
    kartica: 'bg-sky-50 dark:bg-sky-500/10 border-sky-200 dark:border-sky-500/30 hover:border-sky-400',
    chip: 'bg-sky-100 dark:bg-sky-500/25 text-sky-600 dark:text-sky-300',
    znacka: 'bg-sky-100 text-sky-700 dark:bg-sky-500/25 dark:text-sky-200' },
  { id: 'prodaja', naziv: 'Prodaja', podnaslov: 'Izdani računi', aktivna: true, icon: FileOutput, smer: 'izdani_racun', cilj: '/dokumenti?tip=izdani_racun',
    /* [PATCH dostopi-pravice v1] Prodaja pastelno zelena (kot Prihodki v grafih), prej violet */
    kartica: 'bg-green-50 dark:bg-green-500/15 border-green-200 dark:border-green-500/30 hover:border-green-400 dark:hover:border-green-500/60',
    chip: 'bg-green-100 dark:bg-green-500/25 text-green-600 dark:text-green-300',
    znacka: 'bg-green-100 text-green-700 dark:bg-green-500/25 dark:text-green-200' },
  { id: 'nabava', naziv: 'Nabava', podnaslov: 'Prejeti računi', aktivna: true, icon: FileInput, smer: 'prejeti_racun', cilj: '/dokumenti?tip=prejeti_racun',
    /* [PATCH dostopi-pravice v1] Nabava pastelno oranžna (kot Nabava v grafih), prej blue */
    kartica: 'bg-orange-50 dark:bg-orange-500/15 border-orange-200 dark:border-orange-500/30 hover:border-orange-400 dark:hover:border-orange-500/60',
    chip: 'bg-orange-100 dark:bg-orange-500/25 text-orange-600 dark:text-orange-300',
    znacka: 'bg-orange-100 text-orange-700 dark:bg-orange-500/25 dark:text-orange-200' },
  { id: 'banka', naziv: 'Banka', podnaslov: 'Bančni izpiski in plačila', aktivna: true /* [PATCH banka-f1 v1b] */, icon: Landmark, smer: null, cilj: '/banka',
    /* [PATCH banka-f5h v1] rumena (amber, kot rumena vrstica »preveri« na izpisku; prej indigo) */
    kartica: 'bg-amber-50 dark:bg-amber-500/10 border-amber-200 dark:border-amber-500/30 hover:border-amber-400',
    chip: 'bg-amber-100 dark:bg-amber-500/25 text-amber-600 dark:text-amber-300',
    znacka: 'bg-amber-100 text-amber-700 dark:bg-amber-500/25 dark:text-amber-200' },
  { id: 'potni_nalogi', naziv: 'Potni nalogi', podnaslov: 'Službene poti', aktivna: true /* [PATCH pn-deploy-prep v1] */, icon: Route, smer: null, cilj: '/potni-nalogi' /* [PATCH pn-dc-fe v1] [PATCH pn-nalog-fe v1] */,
    /* [PATCH barve-aplikacij v1] rožnata (prej amber) — vsaka aplikacija svoja barva */
    kartica: 'bg-rose-50 dark:bg-rose-500/10 border-rose-200 dark:border-rose-500/30 hover:border-rose-400',
    chip: 'bg-rose-100 dark:bg-rose-500/25 text-rose-600 dark:text-rose-300',
    znacka: 'bg-rose-100 text-rose-700 dark:bg-rose-500/25 dark:text-rose-200' },
  { id: 'delovni_cas', naziv: 'Delovni čas', podnaslov: 'Evidenca delovnega časa', aktivna: true /* [PATCH pn-deploy-prep v1] */, icon: Clock, smer: null, cilj: '/moj-mesec' /* [PATCH pn-dc-fe v1] [PATCH pn-deploy-prep v1] */,
    /* [PATCH barve-aplikacij v1] vijolična (prej teal) — vsaka aplikacija svoja barva */
    kartica: 'bg-violet-50 dark:bg-violet-500/10 border-violet-200 dark:border-violet-500/30 hover:border-violet-400',
    chip: 'bg-violet-100 dark:bg-violet-500/25 text-violet-600 dark:text-violet-300',
    znacka: 'bg-violet-100 text-violet-700 dark:bg-violet-500/25 dark:text-violet-200' },
];

export function opisAplikacije(id: string | null | undefined): AplikacijaOpis | null {
  return APLIKACIJE.find((a) => a.id === id) || null;
}

export function preberiAplikacijo(): AplikacijaId | null {
  try {
    const v = localStorage.getItem(APLIKACIJA_KLJUC);
    return opisAplikacije(v) ? (v as AplikacijaId) : null;
  } catch { return null; }
}

export function shraniAplikacijo(id: AplikacijaId | null) {
  try {
    if (id) localStorage.setItem(APLIKACIJA_KLJUC, id); else localStorage.removeItem(APLIKACIJA_KLJUC);
  } catch {}
  try { window.dispatchEvent(new CustomEvent('aicount-aplikacija', { detail: id })); } catch {}
}

/** Cilj po izbiri podjetja; brez konteksta = stara pot (Dokumenti, prejeti). */
export function ciljAplikacije(id: string | null | undefined): string {
  return opisAplikacije(id)?.cilj || '/dokumenti';
}

export function smerAplikacije(id: string | null | undefined): Smer | null {
  return opisAplikacije(id)?.smer ?? null;
}

/** [PATCH aplikacije-fe v1b] slikovna ikona (frontend/public/aplikacije/<id>.png; build jo prenese na prod) */
export function slikaAplikacije(id: AplikacijaId): string {
  return '/aplikacije/' + id + '.png';
}
